module.exports = __webpack_public_path__ + "img/25761bad-f73c-436d-bc07-670cf37d7270.053.cda0ac41.png";